import React from 'react'
import * as UI from '@brewlogix/blx-ui'

import { useSearch } from '../state/useSearch'
import staticSearchConfig from '../config/staticSearchConfig'
import classNames from 'classnames'

const SearchPagination: React.FC = () => {
    const { currentPage, totalResults, nextPage, prevPage, isSearching } = useSearch()

    return (
        <div className='flex w-full items-center justify-between rounded-b-lg border-px border-t-0 border-gray-100 p-4 lg:p-6'>
            <div className='text-sm text-medium'>
                Page {currentPage} of {Math.ceil(totalResults / staticSearchConfig.limit)}
            </div>

            <div
                className={classNames(
                    'flex items-center gap-x-4 transition-opacity duration-200',
                    isSearching && 'pointer-events-none opacity-70'
                )}
            >
                <UI.Button
                    size='sm'
                    theme='default'
                    disabled={currentPage < 2}
                    customClasses=''
                    onClick={prevPage}
                    label='Previous'
                />

                <UI.Button
                    size='sm'
                    theme='default'
                    disabled={currentPage >= Math.ceil(totalResults / staticSearchConfig.limit)}
                    onClick={nextPage}
                    label='Next'
                />
            </div>
        </div>
    )
}

export default SearchPagination
